/**
 * Множественное число
 * @param {number} i
 * @param {string[]} variants
 * @returns {string}
 */
export const pluralize = (i: number, variants: string[]) => {
  const plural = (a: number) => {
    if (a % 10 === 1 && a % 100 !== 11) {
      return 0;
    }
    if (a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20)) {
      return 1;
    }
    return 2;
  };

  switch (plural(i)) {
    case 0:
      return variants[0];
    case 1:
      return variants[1];
    default:
      return variants[2];
  }
};
